let bush_date_arr = [];
let bush_limit_date_vise_data = {};
function triggerRealCheckout() { 
  const realBtn = document.querySelector('.real_checkout_btn');
  let customer_wholesale_tag_status = document.querySelector('.customer_wholesale_tag_status');
  if (realBtn) {
    if(bush_date_arr.length && customer_wholesale_tag_status && customer_wholesale_tag_status.dataset.status=='false'){
       const formData = new FormData()
       bush_date_arr.forEach(d => formData.append('delivery_date[]', d))
       fetch(
          'https://aprilandashley.lt.agency/subscription_app/public/api/getBushesQtyByDates',
          { method: 'POST', body: formData }
       )
       .then(res => res.json())
       .then(data_daily_bush => {
         if(data_daily_bush.success){
          if(Object.keys(data_daily_bush.delivery_date_count).length){
            let daily_bush_limit_restiction_msgs = [];
            Object.entries(data_daily_bush.delivery_date_count).forEach(([bush_date_key, bush_date_count]) => {
               let total_order_for_current_date = 0;
               if(bush_limit_date_vise_data[bush_date_key]){total_order_for_current_date = bush_date_count + bush_limit_date_vise_data[bush_date_key];}
               let bush_daily_order_limit_ele = document.querySelector('.bush_daily_order_limit');
               let bush_daily_order_limit = parseFloat(bush_daily_order_limit_ele.dataset.limit);
               if(bush_daily_order_limit  && total_order_for_current_date>bush_daily_order_limit){
                  if(bush_date_count>=bush_daily_order_limit){
                    if(typeof window.bushes_daily_limit_reached_msg == 'string'){
                      daily_bush_limit_restiction_msgs.push(window.bushes_daily_limit_reached_msg.replace('{{date}}',bush_date_key));
                    }else{
                      daily_bush_limit_restiction_msgs.push(`Bush products are not available for ${bush_date_key}.`);
                    }
                  }else{
                    if(typeof bushes_checkout_restication_msg =='string'){
                      daily_bush_limit_restiction_msgs.push(bushes_checkout_restication_msg.replace('{{qty}}',total_order_for_current_date-bush_daily_order_limit).replace('{{date}}',bush_date_key));
                    }else{
                      daily_bush_limit_restiction_msgs.push(`Remove ${total_order_for_current_date-bush_daily_order_limit} Bush products from ${bush_date_key} delivery to continue checkout.`);
                    }
                  }
               }
            })
            let daily_bush_limit_limitation_containor = document.querySelector('.daily_bush_limit_limitation_containor');
            if(daily_bush_limit_restiction_msgs.length){
              daily_bush_limit_limitation_containor.innerHTML = '';
              daily_bush_limit_restiction_msgs.forEach((daily_limitation_msg)=>{
                daily_bush_limit_limitation_containor.innerHTML+= `<span class="daily_bush_limit_msg">${daily_limitation_msg}</span`;
              })
              let checkout_copy_btn = document.querySelector('.copy_checkout_btn')
              if(checkout_copy_btn)checkout_copy_btn.classList.remove('btn--loading');
            }else{
               realBtn.click();
               daily_bush_limit_limitation_containor.innerHTML = '';
            }
          }else{
             realBtn.click();
          }
         }else{
           realBtn.click();
         }
       })
       .catch(err => {
         realBtn.click();
       })
    }else{
      realBtn.click();
    }
  }
}



window.update_cart_date_picker_attribute = () => {
  fetch('/cart.js')
    .then(r => {
      if (!r.ok) throw new Error('cart.js API failed');
      return r.json();
    })
    .then(cart => {
      let bouquetDates = [];
      let bushDates = [];
      let attributesToUpdate = {};

       cart.items.forEach(item => {
        let bouquetDate = item.properties?.['Bouquet Delivery Date'];
        let bushDate = item.properties?.['Bush Delivery Date'];

        if (bouquetDate){
           if(attributesToUpdate[`Bouquets_date_${bouquetDate}`]){
            attributesToUpdate[`Bouquets_date_${bouquetDate}`] += item.quantity;
           }else{
            attributesToUpdate[`Bouquets_date_${bouquetDate}`] = item.quantity;
           }
          bouquetDates.push(bouquetDate);
        }
        if (bushDate){
            if(attributesToUpdate[`Bush_date_${bushDate}`]){
              attributesToUpdate[`Bush_date_${bushDate}`] += item.quantity;
              bush_limit_date_vise_data[bushDate] += item.quantity;
            }else{
              attributesToUpdate[`Bush_date_${bushDate}`] = item.quantity;
               bush_limit_date_vise_data[bushDate] = item.quantity;
            }
            bushDates.push(bushDate);
        } 
      });



      // Bouquets-datepicker
      if (bouquetDates.length) {
        attributesToUpdate['Bouquets-datepicker'] = bouquetDates.reduce(
          (latest, current) =>
            new Date(current) > new Date(latest) ? current : latest
        );
      } else {
        attributesToUpdate['Bouquets-datepicker'] = null;
      }

      // Bareroot-datepicker
      if (bushDates.length) {
        attributesToUpdate['Bareroot-datepicker'] = bushDates.reduce(
          (latest, current) =>
            new Date(current) > new Date(latest) ? current : latest
        );
      } else {
        attributesToUpdate['Bareroot-datepicker'] = null;
      }

      if(Object.keys(cart.attributes).length){
        Object.entries(cart.attributes).forEach(([attribute_key, attribute_value]) => {
          if(attribute_key.startsWith('Bush_date') || attribute_key.startsWith('Bouquets_date')){
            if(!attributesToUpdate[attribute_key]){
              attributesToUpdate[attribute_key] = null;
            }
          }
        }); 
      }
      bush_date_arr = bushDates;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributesToUpdate })
      });
    })
    .then(r => {
      if (!r.ok) throw new Error('cart/update.js API failed');
      return r.json();
    })
    .then(() => {
      triggerRealCheckout();
    })
    .catch(err => {
      console.error('Datepicker attribute update failed:', err);
      triggerRealCheckout();
    });
};





window.updateCustomerMetafields = async function(customerID, birthday, anniversary) {
    if (!customerID) return;

    const formData = new FormData();
    formData.append("customerID", customerID);

    if (birthday || birthday=='') formData.append("dob", birthday);
    if (anniversary || anniversary=='') formData.append("anniversary", anniversary);

    try {
        const response = await fetch("https://aprilandashley.lt.agency/subscription_app/public/api/newupdateCustomerMetafields", {
            method: "POST",
            body: formData
        });

        const result = await response.json();
       
        localStorage.removeItem('dd_customer_birthday');
        localStorage.removeItem('dd_customer_anniversary');
        let loyalty_birthday_btn = document.querySelector('.lion-rule-item--birthday button');
        if(loyalty_birthday_btn && birthday != ''){
         const daysUntilBirthday = d => {
            const t = new Date(); t.setHours(0,0,0,0);
            let [_, m, day] = d.split('-').map(Number);
            let b = new Date(t.getFullYear(), m - 1, day);
            if (b <= t) b.setFullYear(t.getFullYear() + 1);
            return Math.ceil((b - t) / 864e5);
          };
          let day_remains = daysUntilBirthday(birthday);
          if(day_remains){
            let day_structure= `<div class="lion-rule-item__limit-reached">${day_remains} days</div>`;
            loyalty_birthday_btn.innerHTML = day_structure;
            loyalty_birthday_btn.classList.add('disable_birthday_reward_click');
          }
        }
        let atleast_one_date_found_text = document.querySelector('.atleast_one_date_found_text');
        if(atleast_one_date_found_text){
          let save_date_both_blank_general = document.querySelector('.save_date_both_blank_general');
          atleast_one_date_found_text.innerHTML = save_date_both_blank_general.innerHTML;
        }
        return result;
    } catch (error) {
        console.error("Error updating metafields:", error);
        throw error;
    }
};


let customer_id_ele = document.querySelector('.customer_id_dd');
if(customer_id_ele){
  let customer_id =  customer_id_ele.dataset.id;
  let dd_customer_birthday = localStorage.getItem('dd_customer_birthday');
  let dd_customer_anniversary = localStorage.getItem('dd_customer_anniversary');
  if (customer_id && (dd_customer_birthday || dd_customer_anniversary)) {
    updateCustomerMetafields(customer_id,dd_customer_birthday,dd_customer_anniversary)
  }
}


let dd_bush_pro_count = 0;
window.IS_UPDATING_WHOLESALE = false;
window.NEEDS_CART_REFRESH = false;

const getDiscountedPrice = (price, percent) => {
  return Math.round(price - (price * percent) / 100);
};

window.update_cart_attr_bush_count = async () => {
  // Prevent re-entry / infinite loops
  if (window.IS_UPDATING_WHOLESALE) return;
  window.IS_UPDATING_WHOLESALE = true;

  const cartDrawer = document.querySelector("#CartDrawer");
  if (cartDrawer) cartDrawer.classList.add("cart-loader");

  try {
    // 1 Fetch latest cart
    const cartRes = await fetch('/cart.js');
    const cart_data = await cartRes.json();

    if (!cart_data?.items?.length) return;

    let totalBushesQty = 0;

    // product_id => { totalQty, lines[] }
    const productMap = {};

    // 2 Calculate bushes qty + group by product
    cart_data.items.forEach((item, index) => {
      if (item.properties && item.properties._wholesale_product === "true"){
        const qty = Number(item.quantity);
        totalBushesQty += qty;

        if (!productMap[item.product_id]) {
          productMap[item.product_id] = { totalQty: 0, lines: [] };
        }

        productMap[item.product_id].totalQty += qty;
        productMap[item.product_id].lines.push(index + 1); // Shopify line index
      }
    });

    // If not wholesale customer → stop here
    if (!window.IS_WHOLESALE_CUSTOMER) return;

    // 4 REMOVE wholesale_price if product qty < 10
    for (const product of Object.values(productMap)) {
      if (product.totalQty >= window.wholesale_minimum_line_item_qty) continue;

      for (const line of product.lines) {
        const item = cart_data.items[line - 1];
        if (!item?.properties?.wholesale_price) continue;

        const props = { ...item.properties };
        delete props.wholesale_price;

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: Object.keys(props).length ? props : {}
          })
        });

        window.NEEDS_CART_REFRESH = true;
      }
    }

    // 5 APPLY wholesale pricing when total >= 200
    if (totalBushesQty >= window.wholesale_minimum_total_qty) {
      for (const product of Object.values(productMap)) {
        if (product.totalQty < window.wholesale_minimum_line_item_qty) continue;

        for (const line of product.lines) {
          const item = cart_data.items[line - 1];
          if (!item) continue;

          let wholesalePrice = window.wholesale_bushes_price;

          // if (totalBushesQty >= 200 && totalBushesQty < 500) {
          //   wholesalePrice = getDiscountedPrice(wholesalePrice, 5);
          // }

          // if (totalBushesQty >= 500 && totalBushesQty < 1000) {
          //   wholesalePrice = getDiscountedPrice(wholesalePrice, 10);
          // }

          // if (totalBushesQty >= 1000) {
          //   wholesalePrice = getDiscountedPrice(wholesalePrice, 20);
          // }

          wholesale_discount_tiers.forEach(tier => {
            const maxValue = tier.max === null ? 9999999 : tier.max;
            if (totalBushesQty >= tier.min && totalBushesQty <= maxValue) {
              wholesalePrice = window.wholesale_bushes_price;
              wholesalePrice = getDiscountedPrice(wholesalePrice, tier.discount);
            }
          });

          console.log("wholesalePrice",wholesalePrice);
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              line,
              quantity: item.quantity,
              properties: {
                ...item.properties,
                wholesale_price: wholesalePrice
              }
            })
          });

          window.NEEDS_CART_REFRESH = true;
        }
      }
    }
    // 6 REMOVE wholesale pricing if total < 200
    if (totalBushesQty < window.wholesale_minimum_total_qty) {
      for (const item of cart_data.items) {
        if (!item?.properties?.wholesale_price) continue;

        const props = { ...item.properties };
        delete props.wholesale_price;

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: Object.keys(props).length ? props : {}
          })
        });

        window.NEEDS_CART_REFRESH = true;
      }
    }

    // 7 Force cart refresh ONLY after all mutations
    if (window.NEEDS_CART_REFRESH) {
      window.NEEDS_CART_REFRESH = false;
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    }

  } catch (error) {
    console.error("update_cart_attr_bush_count error:", error);
  } finally {
    if (cartDrawer) cartDrawer.classList.remove("cart-loader");
    window.IS_UPDATING_WHOLESALE = false;
  }
};


document.addEventListener("DOMContentLoaded", () => {
  window.update_cart_attr_bush_count();
});



let first_available_date_found = false;
let select_first_available_date=()=>{
  let flatpickr_days = document.querySelectorAll('.dayContainer .flatpickr-day');
  flatpickr_days.forEach((day_flatpickr)=>{
    if(!day_flatpickr.classList.contains('flatpickr-disabled') && !first_available_date_found){
      day_flatpickr.click();
      first_available_date_found = true;
    }
  })
  if(!first_available_date_found)setTimeout(select_first_available_date, 2000);
}

let match_date_found = false;
let left_direction_month_disable = false;
let match_date_found_count = 0;
let set_pre_selected_date=(selected_date_locSto)=>{
  match_date_found_count++;
  if(match_date_found_count>8){
    select_first_available_date();
    return;
  }
  if(selected_date_locSto){
    let date_to_reselect = document.querySelector(`.flatpickr-day[aria-label="${selected_date_locSto}"]`);
    if(date_to_reselect){
      match_date_found = true;
      date_to_reselect.click();
    }else{
        let flatpickr_prev_month = document.querySelector('.flatpickr-prev-month');
        if(flatpickr_prev_month && flatpickr_prev_month.classList.contains('flatpickr-disabled')){
          left_direction_month_disable = true;
        }else{
          if(flatpickr_prev_month && !left_direction_month_disable)flatpickr_prev_month.click();
        }

        if(left_direction_month_disable){
          let flatpickr_next_month = document.querySelector('.flatpickr-next-month');
          if(flatpickr_next_month && !flatpickr_next_month.classList.contains('flatpickr-disabled')){
            if(flatpickr_next_month)flatpickr_next_month.click();
          }
        }
        setTimeout(() => {
          set_pre_selected_date(selected_date_locSto);
        }, 1000);
    }
  }
}
let bush_or_bouquet_date_picker = '';
if(__st.p=='product'){
  let pro_date_picker_interval_count = 0;
  let pro_date_picker_interval = setInterval(() => {
    pro_date_picker_interval_count+=1;
    const pro_bush_date_picker = document.querySelector('input[name="properties\\[Bush Delivery Date\\]"]');
    const pro_bouquet_date_picker = document.querySelector('input[name="properties\\[Bouquet Delivery Date\\]"]');
    if(pro_bush_date_picker || pro_bouquet_date_picker){
      if(pro_bush_date_picker){
        bush_or_bouquet_date_picker = 'bush';
        let date_picker_help_text = document.querySelector('[data-child-attribute="help"]');
        let delivery_promise_bushes = document.querySelector('.delivery-promise-bushes');
        if(date_picker_help_text){
          date_picker_help_text.innerHTML = delivery_promise_bushes.innerText;
          date_picker_help_text.style.display="inline";
        }
        let bush_selected_date_loc_sto = localStorage.getItem('bush_selected_date');
        if(bush_selected_date_loc_sto){set_pre_selected_date(bush_selected_date_loc_sto)}else{select_first_available_date();}
      }
      if(pro_bouquet_date_picker){
        bush_or_bouquet_date_picker = 'bouquet';
        let date_picker_help_text = document.querySelector('[data-child-attribute="help"]');
        if(date_picker_help_text){
          let delivery_promise_product_bouquet = document.querySelector('.delivery-promise-product-bouquet');
          date_picker_help_text.innerHTML = delivery_promise_product_bouquet.innerText;
          date_picker_help_text.style.display="inline";
        }
        let bouquet_selected_date_loc_sto = localStorage.getItem('bouquet_selected_date');
        if(bouquet_selected_date_loc_sto){set_pre_selected_date(bouquet_selected_date_loc_sto)}else{select_first_available_date();}
      }
    }
    if(pro_date_picker_interval_count>=40 || pro_bush_date_picker || pro_bouquet_date_picker){
      clearInterval(pro_date_picker_interval);
    }
  }, 1000);
}

let last_line_item_update_cart_response = [];
window.bush_line_item_property_update = async (data) => {
  if (!data.properties ||(!data.properties['Bush Delivery Date'] &&!data.properties['Bouquet Delivery Date'])) return;


  const cartDrawer = document.querySelector("#CartDrawer");

  try {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    const itemsToUpdate = cart.items.filter(item =>
    item.properties && (
        (
          item.properties['Bush Delivery Date'] &&
          data.properties['Bush Delivery Date'] &&
          item.properties['Bush Delivery Date'] !== data.properties['Bush Delivery Date']
        ) ||
        (
          item.properties['Bouquet Delivery Date'] &&
          data.properties['Bouquet Delivery Date'] &&
          item.properties['Bouquet Delivery Date'] !== data.properties['Bouquet Delivery Date']
        )
      )
    );

    const deliveryKeys = [
      'Bush Delivery Date',
      'Bouquet Delivery Date'
    ];
    const deliveryValue =
      data.properties['Bush Delivery Date'] ||
      data.properties['Bouquet Delivery Date'];

    if (!deliveryValue) return;
    if(!itemsToUpdate.length){
      setTimeout(() => {
         document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      }, 2000);
      return;
    };
    cartDrawer.classList.add("cart-loader");
    for (const item of itemsToUpdate) {
      cartDrawer.classList.add("cart-loader");

      const updatedProperties = { ...item.properties };
      for (const key of deliveryKeys) {
        if (updatedProperties[key]) {
          updatedProperties[key] = deliveryValue;
        }
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: item.key,
          properties: updatedProperties
        })
      });
      const cart_response = await response.json();
    }
    
    const refreshedCart = await fetch('/cart.js').then(r => r.json());
    const itemsToUpdate_latest = refreshedCart.items.filter(item =>
    item.properties && (
        (
          item.properties['Bush Delivery Date'] &&
          data.properties['Bush Delivery Date'] &&
          item.properties['Bush Delivery Date'] !== data.properties['Bush Delivery Date']
        ) ||
        (
          item.properties['Bouquet Delivery Date'] &&
          data.properties['Bouquet Delivery Date'] &&
          item.properties['Bouquet Delivery Date'] !== data.properties['Bouquet Delivery Date']
        )
      )
      );
    if(itemsToUpdate_latest.length){
      bush_line_item_property_update(data);
    }else{
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      setTimeout(() => {cartDrawer.classList.remove("cart-loader")}, 1000);
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      }, 2000);
    }
  } catch (err) {
    console.error("Error updating cart", err);
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    setTimeout(() => {cartDrawer.classList.remove("cart-loader")}, 1000);
  }
};



window.show_bouquet_upsell_popup=(data = false)=>{
    // if(localStorage.getItem('recently_added_variant') && localStorage.getItem('recently_added_variant') == data.id){return}
    if(data && data.product_type != 'Bouquets')return;
    if(data && data.selling_plan_allocation)return;
    let bouqeut_total_qty = 0;
    let need_to_show_popup = false;
    fetch('/cart.js')
   .then(res => res.json())
   .then(cart => {
      if(cart.items.length){
        cart.items.forEach((item)=>{
          if(item.product_type == 'Bouquets' && !item.selling_plan_allocation && item.title.includes('12')){
            bouqeut_total_qty+=item.quantity;
          }
        })
        let product_page_atc_popup = document.querySelector('.product_page_atc_popup');
        if(product_page_atc_popup && bouqeut_total_qty%2 == 1){
          setTimeout(() => {
            let upsell_msg_text_ele = product_page_atc_popup.querySelector('.upsell-modal p');
            // if(upsell_msg_text_ele)upsell_msg_text_ele.innerText = upsell_msg_text_ele.innerText.replace('[variant_name]',data.variant_title);
            product_page_atc_popup.classList.remove('hide_product_page_atc_popup');
            document.body.classList.add('body_event_stop');       
            // localStorage.setItem('recently_added_variant',data.id);
            }, 1000);
        }
      }
    });
}



let dd_birthday_date_pickers = document.querySelectorAll('.dd_birthday_date_picker');
dd_birthday_date_pickers.forEach((dd_birthday_date_picker)=>{
  const today = new Date().toISOString().split('T')[0];
  dd_birthday_date_picker.setAttribute('max', today);
})


document.addEventListener('click', async e => {
 const loyalty_birthday_submit_btn = e.target.classList.contains('lion-birthday-entry-form__submit-button');
 if(!loyalty_birthday_submit_btn)return;
  localStorage.setItem('birthday_day_selected_loyalty',true);
});